import React from "react";

/**
 * TO THAI logo — minimal red wordmark.
 * - Inline SVG, no external assets.
 * - Always red, no outline, no glow. Clean & legible on any background.
 * - Variants:
 *     layout="stack"   → "TO" over "THAI" (default — primary brand mark).
 *     layout="inline"  → "TO THAI" on one line (compact use).
 */
export function ToThaiLogo({
  layout = "stack",
  className = "",
  size = "md",
  color = "#F23A2F",
}) {
  const sizeMap = {
    xs: { fontSize: 18, letterSpacing: 1 },
    sm: { fontSize: 28, letterSpacing: 2 },
    md: { fontSize: 44, letterSpacing: 3 },
    lg: { fontSize: 78, letterSpacing: 4 },
    xl: { fontSize: 116, letterSpacing: 6 },
  };
  const s = sizeMap[size] || sizeMap.md;

  const textStyle = {
    fontFamily: '"Anton","Space Grotesk",sans-serif',
    fontWeight: 400,
    fontSize: `${s.fontSize}px`,
    letterSpacing: `${s.letterSpacing}px`,
  };

  if (layout === "inline") {
    const w = Math.round(s.fontSize * 4.6);
    const h = Math.round(s.fontSize * 1.4);
    return (
      <svg
        viewBox={`0 0 ${w} ${h}`}
        width="100%"
        height={h}
        className={className}
        aria-label="TO THAI"
        role="img"
        preserveAspectRatio="xMidYMid meet"
      >
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="central"
          fill={color}
          style={textStyle}
        >
          TO THAI
        </text>
      </svg>
    );
  }

  // Stack layout — "TO" over "THAI"
  const lineHeight = Math.round(s.fontSize * 1.05);
  const totalH = Math.round(lineHeight * 2);
  const w = Math.round(s.fontSize * 3);

  return (
    <svg
      viewBox={`0 0 ${w} ${totalH}`}
      width="100%"
      height={totalH}
      className={className}
      aria-label="TO THAI"
      role="img"
      preserveAspectRatio="xMidYMid meet"
    >
      <text
        x="50%"
        y={lineHeight * 0.5}
        textAnchor="middle"
        dominantBaseline="central"
        fill={color}
        style={textStyle}
      >
        TO
      </text>
      <text
        x="50%"
        y={lineHeight * 1.5}
        textAnchor="middle"
        dominantBaseline="central"
        fill={color}
        style={textStyle}
      >
        THAI
      </text>
    </svg>
  );
}
